














import {Component, Vue} from "vue-property-decorator";
import EForm from "@/components/datatable/EForm.vue";
import Number from "@/components/inputs/Number.vue";
import TextField from "@/components/inputs/TextField.vue";
import ImageShow from "@/components/ImageShow.vue";
import ImageUpload from "@/components/inputs/ImageUpload.vue";
export class havale {
    bankName : String = "";
    bankBranchNo : String = "";
    bankBranchName : String = "";
    bankHesapNo : String = "";
    iban : String = "";
    ibanName : String = "";
    qrcode: String = "";
    qrImageFile!:File;
    fileName : string = "qrcode.png";
}
@Component({
    components: {
        ImageUpload,
        ImageShow,
        EForm,Number,TextField
    }
})
export default class Havale extends  Vue{
    action : string = "config/havale";
    data : havale = new havale();
    async get(){
        let response = await this.$http.get(this.action);
        this.data = response.data;
    }
    created(){
        this.get();
    }
};
